(function () {
  function money(cents, root) {
    var el = root.querySelector('[data-money-format]');
    var fmt = el ? JSON.parse(el.textContent) : '{{amount}}';
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, fmt);
    var n = (cents / 100).toFixed(2);
    var comma = n.replace('.', ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') return comma;
      if (k === 'amount_no_decimals') return Math.round(cents / 100);
      if (k === 'amount_no_decimals_with_comma_separator') return Math.round(cents / 100);
      return n;
    });
  }

  function init(root) {
    if (root.dataset.sparkReady) return;
    root.dataset.sparkReady = '1';
    var info = root.querySelector('.spark-info');

    // Galerie
    var track = root.querySelector('[data-track]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    function go(i) {
      var n = track.children.length;
      i = (i + n) % n;
      track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
    }
    function current() { return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); }
    if (track) {
      var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
      prev && prev.addEventListener('click', function () { go(current() - 1); });
      next && next.addEventListener('click', function () { go(current() + 1); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.dataset.thumb); }); });
      var idx = 0;
      track.addEventListener('scroll', function () {
        var c = current();
        idx = c;
        thumbs.forEach(function (t) { t.classList.toggle('is-active', +t.dataset.thumb === c); });
      }, { passive: true });
      // cand se schimba latimea (telefon intors, fereastra micsorata, editorul trecut pe mobil),
      // galeria ramanea la pozitia veche in pixeli si arata o bucata din alta poza; o readucem pe poza curenta
      var lastW = track.clientWidth;
      function realign() {
        var w = track.clientWidth;
        if (!w || w === lastW) return;
        lastW = w;
        track.style.scrollSnapType = 'none';
        track.scrollLeft = w * idx;
        requestAnimationFrame(function () { track.style.scrollSnapType = ''; });
      }
      if ('ResizeObserver' in window) new ResizeObserver(realign).observe(track);
      else window.addEventListener('resize', realign);
    }

    // Bundle
    var tiers = root.querySelectorAll('[data-tier]');
    function activeTier() { return root.querySelector('[data-tier].is-active') || tiers[0]; }
    function refresh(tier) {
      if (!tier) return;
      var off = +tier.dataset.off || 0, total = 0, compare = 0;
      var sels = tier.querySelectorAll('[data-variant]');
      if (sels.length) {
        sels.forEach(function (s) {
          var o = s.options[s.selectedIndex];
          total += +o.dataset.price; compare += +o.dataset.compare;
        });
      } else {
        var q = +tier.dataset.qty;
        var t0 = tier.querySelector('[data-total]');
        return t0 && updateSticky(t0.textContent);
      }
      total = Math.round(total * (100 - off) / 100);
      var t = tier.querySelector('[data-total]'), c = tier.querySelector('[data-compare]'), sv = tier.querySelector('[data-saved]');
      if (t) t.textContent = money(total, root);
      if (c) c.textContent = money(compare, root);
      if (sv) sv.textContent = money(compare - total, root);
      updateSticky(money(total, root), compare > total ? money(compare, root) : '');
    }
    // 2. Plata rapida: varianta + cantitatea din bundle; ascunsa cand bundle-ul are variante amestecate
    function syncExpress() {
      var f = root.querySelector('.spark-express');
      if (!f) return;
      var list = items();
      var one = list.length === 1;
      f.hidden = !one;
      if (one) {
        f.querySelector('[data-express-id]').value = list[0].id;
        f.querySelector('[data-express-qty]').value = list[0].quantity;
      }
    }
    function updateSticky(txt, cmp) {
      setTimeout(syncExpress, 0);
      var sp = root.querySelector('[data-sticky-price]'), sc = root.querySelector('[data-sticky-compare]');
      if (sp) sp.textContent = txt;
      if (sc) sc.textContent = cmp || '';
    }
    tiers.forEach(function (tier) {
      tier.addEventListener('click', function (e) {
        if (e.target.closest('select')) return;
        tiers.forEach(function (x) { x.classList.toggle('is-active', x === tier); });
        tier.querySelector('input').checked = true;
        refresh(tier);
      });
      tier.querySelectorAll('[data-variant]').forEach(function (s) {
        s.addEventListener('change', function () { refresh(tier); });
      });
    });
    if (tiers.length) refresh(activeTier());
    else updateSticky(money(+info.dataset.defaultPrice, root));

    // Marimea din bara fixa: se aplica tuturor bucatilor din varianta de bundle aleasa
    var sv = root.querySelector('[data-sticky-variant]');
    if (sv) {
      sv.addEventListener('change', function () {
        var tier = activeTier();
        if (tier) {
          tier.querySelectorAll('[data-variant]').forEach(function (s) { s.value = sv.value; });
          refresh(tier);
        } else info.dataset.defaultVariant = sv.value;
      });
      root.addEventListener('change', function (e) {
        if (e.target.matches('[data-variant]')) { var t = activeTier(); var f = t && t.querySelector('[data-variant]'); if (f) sv.value = f.value; }
      });
    }

    // Cerculete de culoare: toate bucatile din bundle (si bara fixa) trec pe culoarea aleasa, marimea ramane;
    // galeria sare la poza variantei
    var sw = root.querySelector('[data-sw]');
    if (sw) {
      var swI = +sw.dataset.swOpt, swData = [];
      try { swData = JSON.parse(sw.querySelector('[data-sw-variants]').textContent); } catch (e) {}
      var byId = {};
      swData.forEach(function (v) { byId[v.id] = v; });
      function swPick(fromId, val) {  // varianta cu culoarea val si restul optiunilor ca la fromId
        var f = byId[fromId], same = null, ok = null, any = null;
        swData.forEach(function (v) {
          if (v.o[swI] !== val) return;
          any = any || v;
          if (v.a) ok = ok || v;
          if (f && v.o.every(function (x, k) { return k === swI || x === f.o[k]; })) same = v;
        });
        return same && same.a ? same : (ok || same || any);
      }
      function swMark(val) {
        sw.querySelectorAll('[data-sw-v]').forEach(function (b) {
          var on = b.dataset.swV === val;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        var nm = sw.querySelector('[data-sw-name]');
        if (nm) nm.textContent = val;
      }
      function swShow(v) {
        if (!v || !v.m || !track) return;
        var slide = track.querySelector('[data-media-id="' + v.m + '"]');
        if (slide) go(+slide.dataset.slide);
      }
      sw.addEventListener('click', function (e) {
        var b = e.target.closest('[data-sw-v]');
        if (!b) return;
        var val = b.dataset.swV, first = null;
        root.querySelectorAll('[data-variant]').forEach(function (s) {
          var v = swPick(+s.value, val);
          if (v) { s.value = v.id; first = first || v; }
        });
        tiers.forEach(function (t) { if (t.querySelector('[data-variant]')) refresh(t); });
        if (tiers.length) refresh(activeTier());
        var cur = swPick(+info.dataset.defaultVariant, val);
        if (cur) info.dataset.defaultVariant = cur.id;
        var svv = root.querySelector('[data-sticky-variant]');
        if (svv && (first || cur)) svv.value = (first || cur).id;
        swMark(val);
        swShow(first || cur);
      });
      // daca clientul schimba culoarea din lista unei bucati, cercul ales o urmeaza
      root.addEventListener('change', function (e) {
        if (!e.target.matches('[data-variant], [data-sticky-variant]')) return;
        var v = byId[+e.target.value];
        if (v) { swMark(v.o[swI]); swShow(v); }
      });
    }

    // Adaugare in cos
    function items() {
      var tier = activeTier();
      if (!tier) return [{ id: +info.dataset.defaultVariant, quantity: 1 }];
      var sels = tier.querySelectorAll('[data-variant]');
      var map = {};
      if (sels.length) sels.forEach(function (s) { map[s.value] = (map[s.value] || 0) + 1; });
      else map[info.dataset.defaultVariant] = +tier.dataset.qty;
      return Object.keys(map).map(function (id) { return { id: +id, quantity: map[id] }; });
    }
    root.querySelectorAll('[data-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-loading')) return;
        btn.classList.add('is-loading');
        var err = root.querySelector('[data-error]');
        if (err) err.hidden = true;
        var drawer = document.querySelector('cart-drawer');
        var body = { items: items() };
        if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
        fetch((window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res.status) throw new Error(res.description || res.message);
          if (drawer && res.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
          else window.location.href = (window.routes && routes.cart_url) || '/cart';
        }).catch(function (e) {
          if (err) { err.textContent = e.message; err.hidden = false; }
        }).finally(function () { btn.classList.remove('is-loading'); });
      });
    });

    // Buton fix: apare dupa ce butonul principal iese din ecran
    var sticky = root.querySelector('[data-sticky]');
    var main = root.querySelector('[data-buy-wrap] [data-add]');
    if (sticky && main && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var below = en[0].boundingClientRect.top < 0;
        var show = !en[0].isIntersecting && below;
        sticky.classList.toggle('is-visible', show);
        // loc liber jos cat e bara vizibila, ca sa nu acopere footer-ul
        document.body.style.paddingBottom = show ? sticky.offsetHeight + 'px' : '';
        document.documentElement.style.setProperty('--spark-sticky-h', show ? sticky.offsetHeight + 'px' : '0px');
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        var b = sticky.querySelector('[data-sticky-btn]');
        if (b) b.tabIndex = show ? 0 : -1;
      }).observe(main);
    }
  }

  // Caseta doar pentru UE (+UK) / doar restul: tara dupa IP, din spark-global.js (window.sparkCountry)
  function euNotes() {
    var notes = document.querySelectorAll('[data-eu-note]');
    if (!notes.length) return;
    // spark-global.js poate sa se incarce dupa acest fisier: atunci pornim noi cererea
    window.SPARK_EU = window.SPARK_EU || 'AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE GB'.split(' ');
    window.sparkCountry = window.sparkCountry || fetch('/browsing_context_suggestions.json')
      .then(function (r) { return r.json(); })
      .then(function (d) { return (d && d.detected_values && d.detected_values.country && d.detected_values.country.handle) || null; })
      .catch(function () { return null; });
    window.sparkCountry.then(function (cc) {
      if (!cc) return;
      var inEu = window.SPARK_EU.indexOf(cc) > -1;
      notes.forEach(function (n) {
        n.hidden = n.getAttribute('data-eu-note') === 'eu' ? !inEu : inEu;
      });
    });
  }

  // 1. Data de livrare: azi + procesare + transport (zile lucratoare daca e bifat), pe regiune; ora limita reala
  function addDays(d, n, skipWe) {
    var x = new Date(d);
    while (n > 0) {
      x.setDate(x.getDate() + 1);
      if (skipWe && (x.getDay() === 0 || x.getDay() === 6)) continue;
      n--;
    }
    return x;
  }
  function fmt(d) {
    try { return d.toLocaleDateString(document.documentElement.lang || 'en', { month: 'short', day: 'numeric' }); }
    catch (e) { return d.toDateString().slice(4, 10); }
  }
  function delivery() {
    document.querySelectorAll('[data-deliv]').forEach(function (el) {
      function draw(cc) {
        var eu = cc && window.SPARK_EU && window.SPARK_EU.indexOf(cc) > -1;
        var we = el.dataset.weekend === 'true', now = new Date();
        var cutoff = +el.dataset.cutoff || 0;
        var start = now;
        if (cutoff && now.getHours() >= cutoff) start = addDays(now, 1, we);
        var shipped = addDays(start, +el.dataset.proc || 0, we);
        var a = addDays(shipped, +(eu ? el.dataset.minEu : el.dataset.min), we);
        var b = addDays(shipped, +(eu ? el.dataset.maxEu : el.dataset.max), we);
        var range = fmt(a) === fmt(b) ? fmt(a) : fmt(a) + ' - ' + fmt(b);
        el.querySelector('[data-deliv-text]').innerHTML = el.dataset.text.replace('[date]', '<b>' + range + '</b>');
        var cut = el.querySelector('[data-deliv-cut]');
        if (cutoff && now.getHours() < cutoff && (!we || (now.getDay() !== 0 && now.getDay() !== 6))) {
          var end = new Date(now); end.setHours(cutoff, 0, 0, 0);
          var m = Math.max(0, Math.round((end - now) / 60000));
          cut.textContent = el.dataset.cutText.replace('[time]', Math.floor(m / 60) + 'h ' + (m % 60) + 'm');
        } else cut.textContent = '';
      }
      draw(null);
      if (window.sparkCountry) window.sparkCountry.then(draw);
      setInterval(function () { if (window.sparkCountry) window.sparkCountry.then(draw); else draw(null); }, 60000);
    });
  }

  // 6. Urgenta: termen fix (acelasi pentru toti). Dupa termen caseta dispare.
  function urgency() {
    document.querySelectorAll('[data-urg-end]').forEach(function (el) {
      var raw = el.dataset.urgEnd.trim().replace(' ', 'T');
      var end = new Date(raw);
      if (isNaN(end)) { el.hidden = true; return; }
      var out = el.querySelector('[data-urg-left]');
      function tick() {
        var left = Math.round((end - Date.now()) / 1000);
        if (left <= 0) { el.hidden = true; return; }
        var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), sec = left % 60;
        out.textContent = (d ? d + 'd ' : '') + String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ':' + String(sec).padStart(2, '0');
      }
      tick(); setInterval(tick, 1000);
    });
  }

  function boot() { document.querySelectorAll('.spark-product').forEach(init); euNotes(); delivery(); urgency(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
